import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Typography from '@material-ui/core/Typography';
import './CardGroup.scss';

const GrbCardGroup = (props) => {
  const {
    icon: Icon,
    className,
    id,
    title,
    children,
  } = props;

  return (
    <section id={id} className={classnames('grb-card-group', className)}>
      {!!title && (
        <header>
          {Icon && <Icon />}
          <Typography variant="h6">{title}</Typography>
        </header>
      )}
      <div className="grb-card-group-body">
        {children}
      </div>
    </section>
  );
};

GrbCardGroup.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]),
  children: PropTypes.node,
};

GrbCardGroup.defaultProps = {
  className: undefined,
  id: undefined,
  title: undefined,
  icon: undefined,
  children: undefined,
};

export default GrbCardGroup;
